export default __webpack_public_path__ + "static/media/megane-medium1.511ae132.jpg";